import * as React from 'react';

import '../../styles/members/recentWorkoutsToLoadPickAndRun.scss';
import { WORKOUT_PAGE_SIZE } from '../membersService';

interface ILoadOption {
  label: string;
  maxPagesPerScope: number;
}

const LOAD_OPTIONS: ILoadOption[] = [
  { label: 'up to 2k', maxPagesPerScope: 1 },
  { label: 'up to 10k', maxPagesPerScope: 5 },
  { label: 'up to 20k', maxPagesPerScope: 10 },
  { label: 'up to 50k (slow)', maxPagesPerScope: 25 },
];

const DEFAULT_OPTION_INDEX = 0;

interface IProps {
  onRun: (maxPagesPerScope: number, estimatedTotal: number) => void;
  disabled?: boolean;
}

interface IState {
  selectedIndex: number;
}

export default class RecentWorkoutsToLoadPickAndRun extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      selectedIndex: DEFAULT_OPTION_INDEX,
    };
  }

  public render() {
    const { disabled } = this.props;
    const { selectedIndex } = this.state;

    return (
      <div className='recent-workouts-to-load-pick-and-run'>
        <select
          value={String(selectedIndex)}
          onChange={this.handleSelectChange}
          disabled={disabled}
          className={'recent-workouts-to-load-pick-and-run__select '
            + 'recent-workouts-to-load-pick-and-run__select--option'}
        >
          {LOAD_OPTIONS.map((opt, idx) => (
            <option key={idx} value={String(idx)}>{opt.label}</option>
          ))}
        </select>

        <button
          onClick={this.handleRun}
          disabled={disabled}
          className='jr-btn-no-border recent-workouts-to-load-pick-and-run__run'
        >
          <img
            className='btnImg refreshIconContainer'
            src={disabled ? 'resources/icons/play-icon-disabled.svg' : 'resources/icons/play-icon.svg'}
            alt='Run'
          />
        </button>
      </div>
    );
  }

  private handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    this.setState({ selectedIndex: Number(e.target.value) });
  };

  private handleRun = () => {
    const { selectedIndex } = this.state;
    const option = LOAD_OPTIONS[selectedIndex];
    this.props.onRun(option.maxPagesPerScope, option.maxPagesPerScope * WORKOUT_PAGE_SIZE);
  };
}
